import * as React from 'react';
export const IcMaskOff = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M5.76 14H5a1 1 0 01-1-1v-2a1 1 0 011-1h1v3.76L14.76 5l-2-.84a2 2 0 00-1.56 0l-4 1.69A2 2 0 006 7.69V8H5a3 3 0 00-3 3v2a3 3 0 002 2.8L5.76 14zM19 8h-1v-.31a2.128 2.128 0 000-.25l2.73-2.73a1.005 1.005 0 00-.71-1.714 1.004 1.004 0 00-.71.294l-16 16a1 1 0 000 1.42.998.998 0 001.42 0l2.34-2.35A4.28 4.28 0 0010.4 20h3.2a4.44 4.44 0 004.4-4h1a3 3 0 003-3v-2a3 3 0 00-3-3zm1 5a1 1 0 01-1 1h-1v-4h1a1 1 0 011 1v2z'
      fill='currentColor'
    />
  </svg>
);
